export function priceFormat(value: number | string) {
  const valueConvert = typeof value === 'string' ? Number(value) : value

  return new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
  }).format(valueConvert)
}
